import { PropsWithChildren } from 'react';

import { Stack } from '@mui/material';
import { tokens } from '../../../../../theme/generated/tokens';

export const Overlay = ({ children }: PropsWithChildren) => {
  return (
    <Stack
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: tokens.theme.bg.structural.overlayLight,
      }}
    >
      {children}
    </Stack>
  );
};
